import { createFileRoute, redirect } from '@tanstack/react-router';
import { DOCGEN_MONTHLY_STATEMENT_JOB_BASE_PATH } from '../../../../../../../../../features/generate/monthly-statement/job/docgen-monthly-statement-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/')({
  beforeLoad: () => {
    throw redirect({ to: DOCGEN_MONTHLY_STATEMENT_JOB_BASE_PATH });
  },
  preload: false,
});
